// extracted by mini-css-extract-plugin
export default {"Wrapper":"FaqSection_Wrapper__j8cik","Title":"FaqSection_Title__Ec42w","List":"FaqSection_List__gpF8e","Answer":"FaqSection_Answer__SZ0hr"};